<p>
  Desde un Input33333: {{ entradaDedato }}
</p>

<button (click)="closeMyModal(false)">Cerrar Modal</button>
<button (click)="emitirEvento()">Emitir evento</button>
